import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import '../styles/gradients.scss'
import '../styles/preisrechner.css'

import ScriptTag from 'react-script-tag'

import contentJSON from '/static/data/content.json'

import PricingState from './Preisrechner/Helpers/PricingState'

import Search from './Preisrechner/Search'
import Maps from './Preisrechner/Maps'
import InputForm from './Preisrechner/InputForm'
import Contact from './Preisrechner/Contact'
import Done from './Preisrechner/Done'
import NavigationButtons from './Preisrechner/NavigationButtons'

const Preisrechner = props => {
    const Wrapper = styled.section`
    position: relative;
    margin: 0 auto;
    width: 90%;
    max-width: 90%;
    min-height: 500px;
    padding: 2rem 0;
    display: block;
    flex-grow: 1;
  `

  const chosenService = useRef(new PricingState());

  const [navigationPageNumber, setNavigationPageNumber] = useState(0);

  const next = () => {
    console.log(chosenService.current.state.Service);
    let pageCondition = {
      0 : () => { return chosenService.current.state.Service.type != -1 ;},
      1 : () => { return chosenService.current.state.Service.coordinates.length > 2 ;},
      2 : () => { return contentJSON.Services[chosenService.current.state.Service.type].preisrechner.filter(x => x.required).map(x=>x.type).every(i=>chosenService.current.state.Service.preisrechner.map(x => x.type).includes(i)) ;},
      3 : () => { return contentJSON.Contact.filter(x => x.required).map(x=>x.type).every(i=>chosenService.current.state.Contact.map(x => x.type).includes(i)) ;}
    }
    if (pageCondition[navigationPageNumber]()){
      if (navigationPageNumber == 0 && !contentJSON.Services[chosenService.current.state.Service.type].perimeter ){
        setNavigationPageNumber(navigationPageNumber+2);
      }
      else {
        setNavigationPageNumber(navigationPageNumber+1);
      }
    } else {
      alert('Bitte befüllen sie alle offenen Felder');
    }
  }
  const back = () => {
    console.log(contentJSON.Services[chosenService.current.state.Service.type]);
    if ((navigationPageNumber == 2 && !contentJSON.Services[chosenService.current.state.Service.type].perimeter) || navigationPageNumber == 1){
        chosenService.current = new PricingState();
        setNavigationPageNumber(0);
    } else
    if (navigationPageNumber == 2 && !contentJSON.Services[chosenService.current.state.Service.type].perimeter){
      setNavigationPageNumber(navigationPageNumber-2);
    }
    else {
      setNavigationPageNumber(navigationPageNumber-1);
    }
  }

  const sendData = () => {
    let transferData = structuredClone(chosenService.current.state);
    transferData.Service.type = contentJSON.Services[chosenService.current.state.Service.type].type;
    let requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(transferData)
    };
    console.log(JSON.stringify(chosenService.current.state));
    fetch('https://api.vermflex.ch/offerservice/', requestOptions)
        .then(response => response.json())
        .then(data => console.log(data));
    console.log(chosenService.current.state);
    window.open('/preise/danke','_self');
  }


  return (
    <Wrapper style={props.style} className='preisrechner vermPrice'>
      <div className="vermContentWrapper">
      
      { ([0,2,3].includes(navigationPageNumber)) &&
        <p className="backgroundNumber"><sup>{(navigationPageNumber == 0)?'1':navigationPageNumber}</sup>&frasl;<sub>3</sub></p>
      }

        
      { (navigationPageNumber == 0) && <Search setService={(x) => chosenService.current.setService(x)} storage={() => chosenService.current.loadServiceData()} /> }
      { (navigationPageNumber == 1 && contentJSON.Services[chosenService.current.state.Service.type].perimeter ) && <Maps storage={() => chosenService.current.loadPerimeterData()} setPerimeterData={(x,y) => chosenService.current.setPerimeterData(x,y)} title={contentJSON.Services[chosenService.current.state.Service.type].name}/> }
      { (navigationPageNumber == 2) && <InputForm actualJson={contentJSON} storage={() => chosenService.current.loadFormData()} service={chosenService.current.state.Service.type} setDataFromId={(id,viewType) => chosenService.current.setDataFromId(id,viewType)} setData={(id,value,viewType) => chosenService.current.setData(id,value,viewType)}/> }
      { (navigationPageNumber == 3) && <Contact actualJson={contentJSON} storage={() => chosenService.current.loadContactData()} service={chosenService.current.state.Service.type} setDataFromId={(id,viewType) => chosenService.current.setContactDataFromId(id,viewType)} setData={(id,value,viewType) => chosenService.current.setContactData(id,value,viewType)} /> }
      { (navigationPageNumber == 4) && <Done pageNumber={navigationPageNumber}/> }
      </div>
      <NavigationButtons next={next} back={back} pageNumber={navigationPageNumber} finalText="Offerte verschicken" finalSubmit={sendData} finalPage={4}/>
        
    </Wrapper>
    )
}

export default Preisrechner